var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{attrs:{"title":"Top Client","bordered":false}},[_c('a-skeleton',{attrs:{"loading":_vm.loading,"active":""}},[_c('chart-top-client',{attrs:{"chart-data":_vm.chartData,"options":_vm.options}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }